module.exports = __webpack_public_path__ + "img/banner04_info_pic2.ef9c6a53.jpg";